import(/* webpackMode: "eager" */ "/workspace/purple-ventures/src/app/not-found.tsx");
